var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement"},[_c('span',{on:{"click":_vm.goAgreement1}},[_vm._v("《会员服务协议》")]),_c('i',[_vm._v("|")]),_c('span',{on:{"click":_vm.goAgreement2}},[_vm._v("《自动续费协议》")])])
}
var staticRenderFns = []

export { render, staticRenderFns }